import { render, staticRenderFns } from "./BtnAddFav.vue?vue&type=template&id=eaa87fd6"
import script from "./BtnAddFav.vue?vue&type=script&lang=js"
export * from "./BtnAddFav.vue?vue&type=script&lang=js"
import style0 from "./BtnAddFav.vue?vue&type=style&index=0&id=eaa87fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports